import BillingType from "./BillingType";

export const LICENSE_USER_ACTIVE_STATUS = "active";

export const LICENSE_USER_TO_REASSIGN_STATUS = "to_reassign";

export type OrganizationLicenseUser = {
    instanceId: string;
    status: string;
    mail: string | null;
};

type OrganizationLicenseProps = {
    id: string;
    name?: string;
    licenseId: string;
    licenseCount: number;
    billingType: BillingType;
    users: OrganizationLicenseUser[];
};

export default class OrganizationLicense {
    id: string;

    name?: string;

    licenseId: string;

    licenseCount: number;

    billingType: BillingType;

    users: OrganizationLicenseUser[];

    constructor({
        id,
        name,
        licenseId,
        licenseCount,
        billingType,
        users,
    }: OrganizationLicenseProps) {
        this.id = id;
        this.name = name;
        this.licenseId = licenseId;
        this.licenseCount = licenseCount;
        this.billingType = billingType;
        this.users = users;
    }
}
